const alertBoldLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-11.2 3.733h-1.6v1.6h1.6zm0-9.333h-1.6v7.467h1.6z" clip-rule="evenodd"/></svg>',
};

export { alertBoldLarge as default };
